var _mask, _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _rect, _rect2, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottts1767950111031(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    fill: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "viewboxMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#viewboxMask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 66)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    stroke: "#2A3544"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 23,
    rx: 16.5,
    ry: 18,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51 36.76c-7.4 4.29-17 1.55-21.42-6.1",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 52.5,
    rx: 16.5,
    ry: 14.5,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    stroke: "#2A3544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.6 60.42c-4.27-7.41-13.95-9.84-21.6-5.42",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.5,
    cy: 22.5,
    rx: 16.5,
    ry: 15.5,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "sidesCables02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 0,
    width: 138,
    height: 72
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 16,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 60,
    width: 16,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 42,
    width: 16,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    width: 16,
    height: 22,
    rx: 2
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sidesCables02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#c0ca33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#topGlowingBulb02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 33a20 20 0 1 1 40 0v11H30V33Z",
    fill: "#fff",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 30,
    rx: 4,
    ry: 6,
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 15.5c4.93 0 9.37 2.13 12.44 5.52m2.43 3.5c.7 1.3 1.21 2.73 1.53 4.23",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 60,
    height: 16,
    rx: 1,
    fill: "#48494B"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "topGlowingBulb02-a",
    x: 22,
    y: 5,
    width: 56,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_617_633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_617_633",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_617_633"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "faceSquare02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12A12 12 0 0 1 12 0h106a12 12 0 0 1 12 12v70a38 38 0 0 1-38 38H38A38 38 0 0 1 0 82V12Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#faceSquare02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h134v124H-2V-2Z",
    fill: "#c0ca33"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 124)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 6,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 6,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 10,
    width: 6,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 10,
    width: 6,
    height: 14,
    rx: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 76)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 91,
    height: 16,
    rx: 4,
    fill: "#000",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eyesRobocop-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 16,
    width: 91,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 91,
    height: 16,
    rx: 4,
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eyesRobocop-a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 7h18L82 37H64L76 7ZM52 7h9L49 37h-9L52 7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottts1767950111031);
export default __webpack_public_path__ + "static/media/bottts-1767950111031.fc90b27ab3522d446637ac136ed9c63d.svg";
export { ForwardRef as ReactComponent };